module.exports = __webpack_public_path__ + "quotezone-ui/img/multipoint-black.9a1c2609.gif";